import { createReduxAsyncThunk } from 'shared/utils';
import dataSources from 'dataSources';

import { BRANDS_STATE } from '../../constants';

import { FavouriteBrand } from '../../types';

export const getFavouriteBrands = createReduxAsyncThunk<{ favouriteBrands: FavouriteBrand[] }>(
  `${BRANDS_STATE}/getFavouriteBrands`,
  async () => {
    return await dataSources.brands.getFavouriteBrands();
  }
);
